// features/rewards/rewardsSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { fetchAllRewards } from '../features/adminAsync';

const initialState = {
  rewards: [],
  loading:false,
  error:null
};

const rewardsSlice = createSlice({
  name: 'rewards',
    initialState,
    error:null,
    loading:false,
     reducers: {
      // any synchronous reducers
    },
    extraReducers: (builder) => {
      builder
        .addCase(fetchAllRewards.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(fetchAllRewards.fulfilled, (state, action) => {
          state.rewards = action.payload;
          state.loading = false;
        })
        .addCase(fetchAllRewards.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        });
    },
});

export const { setRewards } = rewardsSlice.actions;
export default rewardsSlice.reducer;
